import React, { useState } from "react";
import "./AccountCompo.css";
import CheckIcon from "@mui/icons-material/Check";
import CircularProgress from "@mui/material/CircularProgress";
import SaveIcon from "@mui/icons-material/Save";

import {
  TextField,
  Button,
  Typography,
  Box,
} from "@mui/material";

function AccountCompo({ updateAccount, isLoading }) {
  const user = JSON.parse(localStorage.getItem("user"));
  const [name, setName] = useState(user?.name);
  const [email, setEmail] = useState(user?.email);
  const [password, setPassword] = useState("");
  const [isSaved, setIsSaved] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsSaved(false);
      await updateAccount({
        name,
        email,
        password,
      });
      setIsSaved(true);
    } catch (error) {
      console.log(error);
      setIsSaved(false);
    }
  };

  return (
    <Box className="AccountCompo relative">
      <Typography
        variant="h4"
        style={{
          textAlign: "center",
          fontWeight: "bold",
          marginTop: 0,
          marginBottom: "30px",
        }}
      >
        My Account
      </Typography>
      <form onSubmit={handleSubmit}>
        <Box className="user-detail-wrapper">
          <Box className="user-detail-box">
            <TextField
              className="account_input"
              value={name}
              onChange={(e) => setName(e.target.value)}
              type="text"
              name="name"
              variant="outlined"
              label="Name"
              required
              InputProps={{
                style: { color: 'white' }
              }}
              InputLabelProps={{
                style: { color: 'rgb(255 255 255 / 60%)' },
              }}
            />
          </Box>
          <Box className="user-detail-box">
            <TextField
              className="account_input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              name="email"
              variant="outlined"
              label="Email"
              required
              InputProps={{
                style: { color: 'white' }
              }}
              InputLabelProps={{
                style: { color: 'rgb(255 255 255 / 60%)' },
              }}
            />
          </Box>
          <Box className="user-detail-box">
            <TextField
              className="account_input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              name="password"
              label="Password"
              placeholder="******"
              variant="outlined"
              InputProps={{
                style: { color: 'white' }
              }}
              InputLabelProps={{
                style: { color: 'rgb(255 255 255 / 60%)' },
              }}
            />
          </Box>
        </Box>
        <Button
  variant="contained"
  disabled={isLoading || isSaved}
  type="submit"
  style={{
    backgroundColor: isSaved ? '#2dbc47' : '#1976d2',
    color: 'white',
    fontWeight: 'bold',
    borderRadius: '5px',
    padding: '10px',
    cursor: 'pointer',
    position: 'relative',
  }}
  endIcon={isLoading ? null : isSaved ? <CheckIcon /> : <SaveIcon />}
>
  {isSaved ? "Changes saved" : "Save changes"}
  {isLoading && (
    <CircularProgress
      size={24}
      style={{
        display: "inline-flex",
        marginLeft: "8px",
        marginRight: "8px",
        color: 'white'
      }}
    />
  )}
</Button>


        </form>
      </Box>
    );
  }
  
  export default AccountCompo;
  